import {LDUser} from 'launchdarkly-js-client-sdk';

export function authUserToLdUser(authUser?: {
    uid: string;
    email: string | null;
    firstName?: string;
    lastName?: string;
}): LDUser {
    if (authUser?.uid) {
        return {
            key: authUser.uid,

            name: `${authUser.firstName ?? '-'} ${authUser.lastName ?? '-'}`,

            email: authUser.email ?? undefined,
        };
    }

    return {
        anonymous: true,
    };
}
